import React, { useEffect } from "react";
// Libraries
import { useHistory } from "react-router";
// Hooks
import { useEventRequest } from "hooks";
// Components
import { Header, PageContent, PageHeader, Spacer } from "components";
import { ADDRESS_BOOK, CREATE_ADDRESS, SETTINGS } from "constants/Routes";
import { AddressListTable } from "components/Settings/AddressBook/AddressListTable";

const AddressBookList: React.FC = () => {
  const history = useHistory();
  const { eventsRequest } = useEventRequest();

  useEffect(() => {
    eventsRequest({ name: "settings-view-address-book" });
  }, []);

  const handleGoToAddAddress = (): void => {
    history.push(`${SETTINGS}${ADDRESS_BOOK}${CREATE_ADDRESS}`);
  };

  return (
    <>
      <PageHeader>
        <Header
          title="Address Book"
          subTitle="A quick way to capture details of useful contacts to include Previous Keepers, Vets, etc"
        />
      </PageHeader>

      <PageContent
        floatingIconButton={{
          iconName: "plus",
          onClick: handleGoToAddAddress,
        }}
      >
        <Spacer baselineHeight={2} />
        <AddressListTable />
      </PageContent>
    </>
  );
};

export default AddressBookList;
